import slices from './slices';

export default {
  ...slices.shiftsSlice.actions,
  
};
